const startPointPromoCodesEndpoints = {
  base: "/v1/cms/promo-codes",
  byStartPointQuery: (startPointId) =>
    `/v1/cms/promo-codes?startPointId=${encodeURIComponent(String(startPointId || ""))}`,
  byId: (promoCodeId) =>
    `/v1/cms/promo-codes/${encodeURIComponent(String(promoCodeId || ""))}`,
};

export default startPointPromoCodesEndpoints;
